import { Skeleton, Card, Text } from '@nike/eds';
import { Suspense } from 'react';
import { useRoleList } from './hooks';
export function RoleList() {
  return (
    <RoleListShell>
      <RoleListCore />
    </RoleListShell>
  );
}

function RoleListShell({ children }: { children: React.ReactNode }) {
  return (
    <div className='tw-max-w-5xl tw-mx-auto tw-p-10'>
      <p className='eds-type--display-5 tw-mb-4'>Role List</p>
      <Suspense fallback={<RoleListSkeleton />}>{children}</Suspense>
    </div>
  );
}

function RoleListCore() {
  const { data } = useRoleList();
  return (
    <ul className='tw-list-none'>
      {data.roles.map((u: Role) => {
        return (
          <li key={u._id} className='tw-py-2'>
            <RoleItem role={u} />
          </li>
        );
      })}
    </ul>
  );
}

function RoleItem(props: { role: Role }) {
  const role = props.role;
  return (
    <Card padding={16}>
      <div className='tw-flex tw-justify-between'>
        <Text>{role.name}</Text>
        <ul>
          {role.scopes.map((scope) => {
            return <li key={scope}>{scope}</li>;
          })}
        </ul>
      </div>
    </Card>
  );
}

function RoleListSkeleton() {
  return (
    <ul className='tw-list-none'>
      {new Array(10).fill(1, 0).map((u: string, idx: number) => {
        return (
          <li key={idx} className='tw-py-2'>
            <Skeleton height={76} />
          </li>
        );
      })}
    </ul>
  );
}
